import { ProfileType } from '../../../../common/enums/ProfileType';

export class Profile {
  constructor(
    protected readonly id: number,
    protected readonly name: string,
    protected readonly type: ProfileType,
    protected readonly preset: boolean,
    protected readonly disabledRulesNumbers: Set<number>
  ) {}

  getId() {
    return this.id;
  }

  getName() {
    return this.name;
  }

  getType() {
    return this.type;
  }

  isPreset() {
    return this.preset;
  }

  getDisableRulesNumbers() {
    return this.disabledRulesNumbers;
  }
}
